// extracted by mini-css-extract-plugin
export default {"btn":"CommonButton_btn__WI9eA","primary":"CommonButton_primary__BTah1","secondary":"CommonButton_secondary__37WKc"};